import React from "react";
import {
  HomeObjectOne,
  HomeObjectTwo,
  ProjectObject,
  ProjectObjectFour,
  ProjectObjectOne,
  ProjectObjectThree,
  ProjectObjectTwo,
  ProjectEndObject,
} from "./Data";
import InfoSection from "../../components/InfoSection";
import Project from "../../components/Project";

const Home = () => {
  return (
    <>
      <InfoSection {...HomeObjectOne}></InfoSection>
      <InfoSection {...HomeObjectTwo}></InfoSection>
      <Project {...ProjectObject}></Project>
      <InfoSection {...ProjectObjectOne}></InfoSection>
      <InfoSection {...ProjectObjectTwo}></InfoSection>
      <InfoSection {...ProjectObjectThree}></InfoSection>
      <InfoSection {...ProjectObjectFour}></InfoSection>
      <Project {...ProjectEndObject}></Project>
    </>
  );
};

export default Home;
